var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "hsl(7, 71%, 60%)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(7, 71%, 60%)",
    d: "M8.004 10.462V7.596ZM8 5.57v-.042Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "hsl(7, 71%, 60%)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.004 10.462V7.596M8 5.569v-.042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoError);
export default __webpack_public_path__ + "static/media/icon-info-error.144137d3cf4f24aed6743d0127a02d89.svg";
export { ForwardRef as ReactComponent };